import { useQueryClient } from '@tanstack/react-query'
import { shopifyQueryKey } from '../../ShopifyAppContext'
import { useState } from 'react'
import { useShopifyAppContext } from '../../ShopifyAppContext'
import { GoogleSetupPanel } from './GoogleSetupPanel'
/** Settings subpage owns native page/breadcrumbs; property details stay in the embedded app. */
import { shopifyComponentCopy } from '@testfeed/product-language'
import type { ShopifyAppBridge } from '../../shopifyApiFetch'
import { buildSettingsViewUrl } from '../../resultsNavigation'
import { ShopifyIntegrationsPage } from '../ShopifyIntegrationsPage'
import { trackShopifyAction } from '../../shopifyUiTracking'

function ScopedIntegrationsRoute({
  shopify,
  isTestFeedConnected,
}: {
  shopify: ShopifyAppBridge
  isTestFeedConnected: boolean
}) {
  const [googleOpen, setGoogleOpen] = useState(() => new URLSearchParams(window.location.search).has('setupId'))
  const [setupId, setSetupId] = useState(() => new URLSearchParams(window.location.search).get('setupId'))
  const client = useQueryClient()
  const scope = useShopifyAppContext()
  const close = () => {
    setGoogleOpen(false)
    setSetupId(null)
    const url = new URL(window.location.href)
    url.searchParams.delete('setupId')
    url.searchParams.delete('setup_error')
    window.history.replaceState(null, '', url.toString())
  }
  const saved = () => {
    close()
    void client.invalidateQueries({
      queryKey: shopifyQueryKey(scope.shopDomain, scope.orgId, scope.connectionId, ['testfeed-integrations']),
    })
  }
  let googlePanel = null
  if (googleOpen) googlePanel = <GoogleSetupPanel shopify={shopify} setupId={setupId} onClose={close} onSaved={saved} />
  const copy = shopifyComponentCopy.integrationsPage
  return (
    <s-page heading={copy.title} inlineSize="base">
      <s-stack slot="breadcrumb-actions" direction="inline" gap="small-100">
        <s-link
          href={buildSettingsViewUrl()}
          onClick={() => trackShopifyAction(shopify, 'navigate-settings', () => undefined)}
        >
          {copy.settings}
        </s-link>
        <s-text>›</s-text>
        <s-text>{copy.title}</s-text>
      </s-stack>
      <ShopifyIntegrationsPage
        shopify={shopify}
        isTestFeedConnected={isTestFeedConnected}
        onConnectGoogle={() => {
          trackShopifyAction(shopify, 'open-provider', () => {
            setSetupId(null)
            setGoogleOpen(true)
          })
        }}
      />
      {googlePanel}
    </s-page>
  )
}

export function IntegrationsRoute(props: { shopify: ShopifyAppBridge; isTestFeedConnected: boolean }) {
  const scope = useShopifyAppContext()
  return (
    <ScopedIntegrationsRoute key={JSON.stringify([scope.orgId, scope.shopDomain, scope.connectionId])} {...props} />
  )
}
